import React, { useCallback, useMemo } from 'react';
import { Checkbox, TextLinkifyTags } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

export const SweetpassCheckoutCheckbox = (
  props: SweetpassCheckoutCheckboxProps,
) => {
  const { termsAndConditions, hasAcceptedTerms, handleAcceptTerms } = props;

  const { t } = useLocalizationContext();

  const links: React.ComponentProps<typeof TextLinkifyTags>['links'] = useMemo(
    () => [
      {
        tag: 'sweetpassProgramAgreement',
        description: t('sweetpass.checkout.terms.sweetpass-program-agreement'),
        href: 'https://www.sweetgreen.com/sweetpass-program-agreement',
        newTab: true,
        underline: true,
      },
      {
        tag: 'hello@sweetgreen.com',
        description: 'hello@sweetgreen.com',
        href: 'mailto:hello@sweetgreen.com',
        newTab: true,
        underline: true,
      },
    ],
    [t],
  );

  const onCheckTerms = useCallback(
    (checked?: boolean) => {
      handleAcceptTerms(checked ?? false);
    },
    [handleAcceptTerms],
  );

  return (
    <Checkbox
      testID="sweetpass.checkout.accept"
      alignment="start"
      checked={hasAcceptedTerms}
      onChange={onCheckTerms}
      isBoxed
    >
      <TextLinkifyTags links={links} palette="kale" sizeMatch={['16']}>
        {termsAndConditions}
      </TextLinkifyTags>
    </Checkbox>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type SweetpassCheckoutCheckboxProps = Readonly<{
  termsAndConditions: string;
  hasAcceptedTerms: boolean;
  handleAcceptTerms: (hasAcceptedTerms: boolean) => void;
}>;
